/* eslint-disable class-methods-use-this */
import WebRequest from '../WebRequest';
import debounce from '../Utils/debouncer';

let uuid = 0;
function nextUUID() {
  uuid += 1;
  return uuid;
}

/**
 * Load the seach list.
 * If a search/cancel request is done (A) when a previous request is running (B),
 * the result of (B) is discarded.
 */
export default class SearchListProvider {
  /**
   * The subscriber is a object with this shape:
   * cancel: callback called when cancel is invoke.
   * searchStarted: callback called when search started.
   * searchCompleted: callback called when search finished.
   * loaded: callback called with response data.
   * errorCatched: callback called with response error.
   */
  constructor(subscriber) {
    this.subscriber = subscriber;
  }

  /**
   * Start a new search.
   */
  searchDebounced = debounce((searchProps, searchTerm, closeList, requestId) => {
    if (requestId !== this.lastRequestId) return;
    this.searchImpl(searchProps, searchTerm, closeList, requestId);
  }, 300, false);

  /**
   * Start a new search.
   */
  search(searchProps, searchTerm, closeList) {
    this.lastRequestId = nextUUID();
    this.searchDebounced(searchProps, searchTerm, closeList, this.lastRequestId);
  }

  /**
   * Start a new search NOW.
   * It doesn't use debounce!
   */
  searchNow(searchProps, searchTerm, closeList) {
    this.lastRequestId = nextUUID();
    return this.searchImpl(searchProps, searchTerm, closeList, this.lastRequestId);
  }

  /**
 * Cancel the last search (if it exists).
 */
  cancel() {
    this.lastRequestId = nextUUID();
    this.subscriber && this.subscriber.cancel();
  }

  webGet(url, params) {
    return WebRequest.get(url, params);
  }

  /**
   * Server GET
   * @private
   */
  get(searchProps, params) {
    const { url, dataSource, renderProperty } = searchProps;
    if (url) return this.webGet(url, params);
    if (dataSource && typeof dataSource === 'function') return dataSource({ ...params, renderProperty });
    if (dataSource && Array.isArray(dataSource)) {
      const list = dataSource.filter(
        (x) => x[renderProperty].toLowerCase().indexOf(params.term.toLowerCase()) !== -1,
      );
      return Promise.resolve(list);
    }
    return Promise.resolve([]);
  }

  /**
 * @private
 */
  searchImpl(searchProps, searchTerm, closeList, requestId) {
    if (this.subscriber === undefined) return Promise.resolve();
    this.subscriber.searchStarted();
    return this.get(searchProps, { term: searchTerm })
      .then((response) => {
        if (this.subscriber === undefined || this.lastRequestId !== requestId) return;
        this.subscriber.searchCompleted();
        this.subscriber.loaded(response, closeList);
      }).catch((error) => {
        if (this.subscriber === undefined || this.lastRequestId !== requestId) return;
        this.subscriber.searchCompleted();
        this.subscriber.errorCatched(error);
      });
  }
}
